import { defaultLocale, ILocale } from '@/config/locales';

import { TRootState } from '../rootReducer';

export const getLocale = (state: TRootState): ILocale => state.routerLocale || defaultLocale;
